export class HrPerEvaluationAreaDefinitionKey {
    private static readonly keyPrefix = 'hrPerEvaluationAreaDef';
    public static title = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.pageHeader`;
    public static enumViewOption = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.enumViewOption`;
    public static objectNumber = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.objectNumber`;
    public static step = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.step`;
    public static evaluationUnit = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.evaluationUnit`;
    public static minValue = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.minValue`;
    public static maxValue = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.maxValue`;
    public static maxScore = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.maxScore`;
    public static calculationDirection = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.calculationDirection`;
    public static goalValue = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.goalValue`;
    public static result = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.result`;
    public static note = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.note`;
    public static weight = `${HrPerEvaluationAreaDefinitionKey.keyPrefix}.weight`;
}
